import { render } from "./SubTitle.vue?vue&type=template&id=528a4efd&scoped=true"
import script from "./SubTitle.vue?vue&type=script&lang=js"
export * from "./SubTitle.vue?vue&type=script&lang=js"

import "./SubTitle.vue?vue&type=style&index=0&id=528a4efd&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528a4efd"]])

export default __exports__